import URI from "urijs";

const DEFAULT_API_SEGMENT = ["authentication", "v1"];

class AuthenticationURIBuilder {
  public apiUrl: string | null;
  public apiSegment: string[];
  public segment: string[] | null;
  public query: object = {};

  constructor() {
    this.apiUrl = null;
    this.apiSegment = DEFAULT_API_SEGMENT;
  }

  public setApiUrl(apiUrl: string): AuthenticationURIBuilder {
    this.apiUrl = apiUrl;
    const { path } = URI.parse(apiUrl);

    if (path && path !== "/") {
      this.apiSegment = [path, ...this.apiSegment];
    }
    return this;
  }

  public setSegment(segment: string | string[]): AuthenticationURIBuilder {
    const localSegment = Array.isArray(segment) ? segment : segment.split("/");
    this.segment = localSegment;

    return this;
  }

  public setQuery(query: object): AuthenticationURIBuilder {
    this.query = query;
    return this;
  }

  public build(): ReturnType<typeof URI> {
    const { apiUrl, apiSegment, segment, query } = this;
    return new URI(apiUrl).segment([...apiSegment, ...(segment ? segment : [])].map((s) => String(s))).setQuery(query);
  }

  public toString(): string {
    return String(this.build());
  }
}

export default AuthenticationURIBuilder;
